import { useWorkspaceView, WORKSPACE_VIEW_LABELS } from '../lib/workspaceView.jsx';

/**
 * HR / Admin tabs in the top bar — same pattern as CRM's Counsellor…Admin switcher.
 * Only ADMIN accounts see both; everyone else stays on their natural desk.
 */
export default function WorkspaceViewSwitcher() {
  const { workspaceView, setWorkspaceView, canSwitchWorkspaceView, availableViews } = useWorkspaceView();

  if (!canSwitchWorkspaceView || availableViews.length <= 1) return null;

  return (
    <div className="view-switch-group">
      <div className="view-switch" role="tablist" aria-label="Workspace view">
        {availableViews.map((view) => (
          <button
            key={view}
            type="button"
            role="tab"
            aria-selected={workspaceView === view}
            className={`view-switch-btn${workspaceView === view ? ' active' : ''}`}
            onClick={() => setWorkspaceView(view)}
          >
            {WORKSPACE_VIEW_LABELS[view] || view}
          </button>
        ))}
      </div>
    </div>
  );
}
